// @flow
import _ from 'lodash'
import { ADD, DELETE, SET, UPDATE, MARK_INITIALIZED } from '../../mutation-types'

export default {
  [SET](state, { items }: { items: Array<Object> }) {
    state.items = [...items]
  },
  [ADD](state, { data }: { data: Object }) {
    const item = data
    if (
      state.itemsInitialized &&
      item &&
      item.id &&
      _.isEmpty(_.find(state.items, { id: item.id }))
    ) {
      state.items.push(_.cloneDeep(item))
    }
  },
  [UPDATE](state, { data }: { data: Object }) {
    const item = data
    if (state.itemsInitialized) {
      const idx = _.findIndex(state.items, i => i.id === item.id)
      if (idx >= 0 && state.items[idx].version !== item.version) {
        state.items.splice(idx, 1, item)
      } else if (idx < 0) {
        state.items.push(_.cloneDeep(item))
      }
    }
  },
  [DELETE](state, { id }: { id: string }) {
    const idx = _.findIndex(state.items, i => i.id === id)
    if (idx >= 0) state.items.splice(idx, 1)
  },
  [MARK_INITIALIZED](state) {
    state.itemsInitialized = true
  }
}
